export default "__VITE_ASSET__Nib9rOVS__"